import React, { useState } from "react";
import {
  TextField,
  Popover,
  List,
  ListItemButton,
  ListItemText,
  Collapse,
  InputAdornment,
} from "@mui/material";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";

const ExpandableFunctionDropdown = ({
  value,
  groups = [],
  onChange,
  disabled = false,
}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [expanded, setExpanded] = useState("");

  const open = Boolean(anchorEl);

  const handleOpen = (event) => {
    if (!disabled) setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
    setExpanded("");
  };

  const toggleGroup = (title) => {
    setExpanded((prev) => (prev === title ? "" : title));
  };

  const selectItem = (groupTitle, item) => {
    onChange({
      group: groupTitle,
      item,
    });
    handleClose();
  };

  return (
    <>
      <TextField
        fullWidth
        size="small"
        value={value}
        onClick={handleOpen}
        disabled={disabled}
        // placeholder="Select Function"
        InputProps={{
          readOnly: true,
          endAdornment: (
            <InputAdornment position="end">
              <ArrowDropDownIcon />
            </InputAdornment>
          ),
        }}
      />

      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
      >
        <List sx={{ width: 250, maxHeight: 300, overflow: "auto" }}>
          {groups.map((group) => (
            <div key={group.title}>
              <ListItemButton onClick={() => toggleGroup(group.title)}>
                {expanded === group.title ? (
                  <ExpandMoreIcon fontSize="small" />
                ) : (
                  <ChevronRightIcon fontSize="small" />
                )}

                <ListItemText
                  primary={group.title}
                  primaryTypographyProps={{ fontWeight: 600 }}
                />
              </ListItemButton>

              <Collapse
                in={expanded === group.title}
                timeout="auto"
                unmountOnExit
              >
                <List disablePadding>
                  {group.items.map((item) => (
                    <ListItemButton
                      key={item}
                      sx={{ pl: 5 }}
                      onClick={() => selectItem(group.title, item)}
                    >
                      <ListItemText primary={item} />
                    </ListItemButton>
                  ))}
                </List>
              </Collapse>
            </div>
          ))}
        </List>
      </Popover>
    </>
  );
};

export default ExpandableFunctionDropdown;